import { render, staticRenderFns } from "./Beds.vue?vue&type=template&id=ed071eae&scoped=true"
import script from "./Beds.vue?vue&type=script&lang=js"
export * from "./Beds.vue?vue&type=script&lang=js"
import style0 from "./Beds.vue?vue&type=style&index=0&id=ed071eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed071eae",
  null
  
)

export default component.exports